import type { MyFilesResource } from "@/features/my-files/myFilesSchemas";

export const MY_FILES_SELECTION_LIMIT = 100;

export function updateMyFilesSelection(
  selectedIds: ReadonlyArray<string>,
  resourceId: string,
  isSelected: boolean,
) {
  if (!isSelected) {
    return selectedIds.filter((id) => id !== resourceId);
  }
  if (selectedIds.includes(resourceId)) return selectedIds;
  if (selectedIds.length >= MY_FILES_SELECTION_LIMIT) return selectedIds;
  return [...selectedIds, resourceId];
}

export function addMyFilesSelection(
  selectedIds: ReadonlyArray<string>,
  resourceIds: ReadonlyArray<string>,
) {
  const next = new Set(selectedIds);
  for (const resourceId of resourceIds) {
    if (next.size >= MY_FILES_SELECTION_LIMIT) break;
    next.add(resourceId);
  }
  return [...next];
}

export function canDeleteMyFilesSelection(
  resources: ReadonlyArray<MyFilesResource>,
) {
  return (
    resources.length > 0 &&
    resources.every((resource) =>
      resource.availableActions.includes("delete"),
    )
  );
}

export function shouldClearMyFilesSelection(
  reason: "exit-managing" | "filter-change" | "layout-change" | "search-change",
) {
  return reason !== "layout-change";
}
